(() => {
  const STICKY_BUTTON = [
    'sticky-atc .sticky-atc__button button.main-product-atc[form]',
    'sticky-atc .sticky-atc__button button.sticky-atc__scroll-btn'
  ].join(', ');
  const DEAL_BAR = '.kaching-bundles__bar[data-deal-bar-id]';
  const STANDARD_EVENTS_URL = 'https://cdn.shopify.com/storefront/standard-events.js';
  
  const VARIANT_BY_DEAL = {
    xgmS: '53651553091860',
    VKgB: '53651553124628',
    '01Lu': '53651553124628'
  };
  const BUNDLE_LABEL_BY_QUANTITY = {
    2: 'Tratamiento de 2 meses',
    3: 'Tratamiento de 3 meses',
    5: 'Tratamiento de 5 meses'
  };
  const QUANTITY_BY_DEAL = { xgmS: 2, VKgB: 3, '01Lu': 5 };
  const SUBSCRIPTION_PLAN_ID = '691845923092';
  let priceTimer = 0;
  let cartTimer = 0;
  let cartRefreshRun = 0;
  let cartFallbackInterval = 0;
  let standardEvents = null;
  const analyticsHandledResponses = new WeakSet();

  import(STANDARD_EVENTS_URL)
    .then((module) => {
      standardEvents = module;
    })
    .catch((error) => {
      console.warn('[SELYNE] No se pudieron cargar los eventos estándar de Shopify', error);
    });

  window.__selyneCurrentBundleSticky1808 = true;
  document.documentElement.dataset.selyneStickyEvents = 'true';

  const dealBars = () => [...document.querySelectorAll(DEAL_BAR)];
  const selectedDealBar = () =>
    document.querySelector(DEAL_BAR + '.kaching-bundles__bar--selected') ||
    dealBars().find((bar) => bar.querySelector('input[type="radio"]')?.checked) ||
    dealBars()[0];

  const subscriptionSelected = () =>
    document.querySelector('.kaching-bundles__subscriptions .kaching-bundles__bar')
      ?.getAttribute('aria-checked') === 'true';

  function cartAddItemsFromBody(body) {
    if (!body) return [];
    if (body instanceof URLSearchParams) return cartAddItemsFromBody(body.toString());
    if (typeof body === 'string') {
      try {
        const payload = JSON.parse(body);
        if (Array.isArray(payload.items)) return payload.items;
        return payload.id ? [payload] : [];
      } catch (error) {
        const params = new URLSearchParams(body);
        const id = params.get('id');
        return id ? [{ id, quantity: params.get('quantity') || 1 }] : [];
      }
    }
    if (body instanceof FormData) {
      const items = [];
      body.forEach((value, key) => {
        const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (match) {
          items[Number(match[1])] ||= {};
          items[Number(match[1])][match[2]] = value;
        }
      });
      if (items.filter(Boolean).length) return items.filter(Boolean);
      const id = body.get('id');
      return id ? [{ id, quantity: body.get('quantity') || 1 }] : [];
    }
    return [];
  }

  async function cartAddRequestDetails(args) {
    const body = args[1]?.body;
    let items = cartAddItemsFromBody(body);
    let nativeUnsupported = false;

    if (typeof Request !== 'undefined' && args[0] instanceof Request) {
      nativeUnsupported = true;
      if (!items.length) {
        try {
          items = cartAddItemsFromBody(await args[0].clone().text());
        } catch (error) {
          items = [];
        }
      }
    } else if (body instanceof URLSearchParams) {
      nativeUnsupported = true;
    } else if (typeof body === 'string') {
      try {
        JSON.parse(body);
      } catch (error) {
        nativeUnsupported = true;
      }
    } else if (body instanceof FormData && items.length > 1) {
      const ids = items.map((item) => String(item.id || ''));
      nativeUnsupported = new Set(ids).size !== ids.length;
    }

    return { items, nativeUnsupported };
  }

  function readCartCookie() {
    try {
      const value = new RegExp('(cart)=([^;]+)').exec(document.cookie)?.[2];
      return value ? decodeURIComponent(value) : null;
    } catch (error) {
      return null;
    }
  }

  function trackShopifyBundleAdd(item, responseItems = [], attempt = 0) {
    const variantId = String(item.id || '');
    if (!Object.values(VARIANT_BY_DEAL).includes(variantId)) return;

    const analytics = window.ShopifyAnalytics;
    if (!analytics?.lib?.track) {
      if (attempt < 8) {
        document.documentElement.dataset.selyneAnalyticsFallback = 'waiting';
        setTimeout(() => trackShopifyBundleAdd(item, responseItems, attempt + 1), 250);
      } else {
        document.documentElement.dataset.selyneAnalyticsFallback = 'analytics-unavailable';
      }
      return;
    }

    const responseItem = responseItems.find((entry) =>
      String(entry?.variant_id || entry?.id || '') === variantId
    );

    const products = analytics.meta?.products || [analytics.meta?.product].filter(Boolean);
    let product = null;
    let variant = null;
    products.some((candidate) => {
      const match = candidate?.variants?.find((entry) => String(entry.id) === variantId);
      if (!match) return false;
      product = candidate;
      variant = match;
      return true;
    });

    const page = analytics.meta?.page || {};
    const eventProperties = {
      cartToken: readCartCookie(),
      variantId,
      productId: responseItem?.product_id || product?.id,
      currency: analytics.meta?.currency,
      quantity: String(Number(item.quantity) || 1),
      price: responseItem?.presentment_price ?? (variant?.price ? variant.price / 100 : undefined),
      name: responseItem?.title || variant?.name,
      sku: responseItem?.sku || variant?.sku,
      brand: responseItem?.vendor || product?.vendor,
      category: responseItem?.product_type || product?.type,
      variant: responseItem?.variant_title || variant?.public_title,
      remote: responseItem?.remote || product?.remote || product?.isRemoteProduct || null,
      pageType: page.pageType,
      resourceType: page.resourceType,
      resourceId: page.resourceId
    };

    try {
      analytics.lib.track('Added Product', eventProperties, undefined, undefined, {
        addApiSource: 'add-fetch-bulk',
        shopifyEmitted: true
      });
      document.documentElement.dataset.selyneAnalyticsFallback = 'tracked';
    } catch (error) {
      document.documentElement.dataset.selyneAnalyticsFallback = 'track-error';
      console.warn('[SELYNE] No se pudo registrar el añadido en Analytics', error);
    }
  }

  function installShopifyAnalyticsFallback() {
    if (window.fetch?.__selyneAnalyticsFallback === true) return;
    const previousFetch = window.fetch;
    if (typeof previousFetch !== 'function') return;

    const trackedFetch = function (...args) {
      const requestUrl =
        typeof args[0] === 'string' || args[0] instanceof URL
          ? String(args[0])
          : args[0]?.url;
      const requestDetails = cartAddRequestDetails(args);

      return previousFetch.apply(this, args).then((response) => {
        try {
          const path = new URL(requestUrl || response.url, window.location.origin).pathname;
          const isCartAdd =
            /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/cart\/add(?:\.js|\.json)?\/?$/i.test(path);
          if (!response.ok || !isCartAdd || analyticsHandledResponses.has(response)) return response;
          analyticsHandledResponses.add(response);

          Promise.all([requestDetails, response.clone().json()])
            .then(([details, payload]) => {
              if (!details.items.length) return;
              const responseItems = Array.isArray(payload?.items) ? payload.items : [payload];
              const responseMismatch = responseItems.length !== details.items.length;
              if (!details.nativeUnsupported && !responseMismatch) return;
              details.items.forEach((item) => trackShopifyBundleAdd(item, responseItems));
            })
            .catch(() => {});
        } catch (error) {
          console.warn('[SELYNE] No se pudo completar el respaldo de Analytics', error);
        }
        return response;
      });
    };

    Object.defineProperty(trackedFetch, '__selyneAnalyticsFallback', { value: true });
    window.fetch = trackedFetch;
  }

  function installCriticalStyles() {
    if (document.getElementById('selyne-kaching-critical-styles')) return;
    const style = document.createElement('style');
    style.id = 'selyne-kaching-critical-styles';
    style.textContent = `
      .kaching-bundles__bar[data-deal-bar-id="VKgB"] .kaching-bundles__highlights,
      .kaching-bundles__bar[data-deal-bar-id="8qWV"] .kaching-bundles__highlights {
        box-sizing: border-box;
        min-height: 44px;
        margin: 10px -19px -9px !important;
        padding: 7px 20px 7px 8px !important;
        border-radius: 0 0 13px 13px;
        background: rgba(75, 191, 218, 1) !important;
      }
      .kaching-bundles__bar[data-deal-bar-id="VKgB"] .kaching-bundles__highlights__icon,
      .kaching-bundles__bar[data-deal-bar-id="8qWV"] .kaching-bundles__highlights__icon {
        width: 30px !important;
        height: 30px !important;
        flex: 0 0 30px;
        border-radius: 7px;
        background: url("https://cdn.shopify.com/s/files/1/1011/6205/8004/files/selyne-regalo-envio-express_200x200.png?v=1786749813") center / cover no-repeat;
        color: transparent !important;
      }
      .kaching-bundles__bar[data-deal-bar-id="VKgB"] .kaching-bundles__highlights__icon svg,
      .kaching-bundles__bar[data-deal-bar-id="8qWV"] .kaching-bundles__highlights__icon svg {
        display: none !important;
      }
      .kaching-bundles__bar[data-deal-bar-id="VKgB"] .kaching-bundles__highlights__text,
      .kaching-bundles__bar[data-deal-bar-id="8qWV"] .kaching-bundles__highlights__text {
        font-size: 0 !important;
        color: #fff !important;
        font-weight: 700 !important;
      }
      .kaching-bundles__bar[data-deal-bar-id="VKgB"] .kaching-bundles__highlights__text::after,
      .kaching-bundles__bar[data-deal-bar-id="8qWV"] .kaching-bundles__highlights__text::after {
        content: "+ ENVÍO EXPRESS CON SEGUIMIENTO GRATIS";
        font-size: 13px;
        line-height: 18.2px;
      }
      cart-drawer .cart-item__details a,
      cart-drawer .cart-item__details .product-option {
        text-decoration: none !important;
        border-bottom: 0 !important;
        box-shadow: none !important;
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  }

  function syncProductVariant(bar = selectedDealBar()) {
    const variantId = VARIANT_BY_DEAL[bar?.dataset.dealBarId];
    if (!variantId) return;
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      if (input.value === variantId) return;
      input.value = variantId;
      input.setAttribute('value', variantId);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function normalizeDrawerBundleLabels(drawer = document.querySelector('cart-drawer')) {
    if (!drawer) return;
    const rows = [...drawer.querySelectorAll('.cart-item')].filter((row) =>
      row.querySelector('a[href*="/products/selyne-balsamo-reparador-para-eczema-psoriasis"]')
    );
    if (!rows.length) return;
    const totalQuantity = rows.reduce((total, row) => {
      const input = row.querySelector('input[name="updates[]"]');
      return total + Number(input?.value || 0);
    }, 0);
    const label = BUNDLE_LABEL_BY_QUANTITY[totalQuantity];
    if (!label) return;
    rows.forEach((row) => {
      row.querySelectorAll('.product-option').forEach((option) => {
        option.textContent = label;
      });
    });
  }

  function startCartTimer(drawer = document.querySelector('cart-drawer')) {
    const timer = drawer?.querySelector('.cart-timer');
    if (!timer || !drawer.classList.contains('active')) return;
    const parts = [...timer.querySelectorAll('*')].filter((node) =>
      node.children.length === 0 && /^\d{2}$/.test(node.textContent.trim())
    ).slice(0, 2);
    if (parts.length < 2) return;
    let remaining = Number(parts[0].textContent) * 60 + Number(parts[1].textContent);
    if (!Number.isFinite(remaining) || remaining <= 0) remaining = 170;
    clearInterval(cartFallbackInterval);
    timer.dataset.selyneTimerRunning = 'true';
    cartFallbackInterval = window.setInterval(() => {
      if (!document.contains(timer) || !drawer.classList.contains('active')) {
        clearInterval(cartFallbackInterval);
        cartFallbackInterval = 0;
        delete timer.dataset.selyneTimerRunning;
        return;
      }
      remaining = Math.max(0, remaining - 1);
      parts[0].textContent = String(Math.floor(remaining / 60)).padStart(2, '0');
      parts[1].textContent = String(remaining % 60).padStart(2, '0');
      if (remaining === 0) {
        clearInterval(cartFallbackInterval);
        cartFallbackInterval = 0;
      }
    }, 1000);
  }

  function ensureThemeEditorMarket() {
    if (!window.Shopify?.designMode) return false;
    const url = new URL(window.location.href);
    if (url.searchParams.get('country') === 'MX') return false;
    url.searchParams.set('country', 'MX');
    window.location.replace(url.toString());
    return true;
  }

  const numberFromMoney = (text) => {
    if (!text) return null;
    const cleaned = text.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    const value = Number.parseFloat(cleaned);
    return Number.isFinite(value) ? value : null;
  };

  function ensurePrice(sticky) {
    let price = sticky.querySelector('.selyne-sticky-price');
    if (!price) {
      price = document.createElement('div');
      price.className = 'selyne-sticky-price';
      sticky.querySelector('.sticky-atc__left__content')?.appendChild(price);
    }
    return price;
  }

  function syncStickyPrice() {
    priceTimer = 0;
    const sticky = document.querySelector('sticky-atc');
    const bar = selectedDealBar();
    if (!sticky || !bar) return;
    syncProductVariant(bar);

    sticky.classList.add('selyne-bundle-sticky-ready');
    sticky.dataset.selyneReady = 'true';

    const bars = dealBars();
    const selectedIndex = Math.max(0, bars.indexOf(bar));
    const select = sticky.querySelector('select.sticky-atc__variant-select');
    if (select && select.selectedIndex !== selectedIndex && select.options[selectedIndex]) {
      select.selectedIndex = selectedIndex;
    }

    const currentText = bar.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
    const compareText =
      
      bar.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();
    if (!currentText) return;

    const price = ensurePrice(sticky);
    const current = document.createElement('strong');
    current.textContent = currentText;
    const children = [current];

    if (compareText && compareText !== currentText) {
      const compare = document.createElement('s');
      compare.textContent = compareText;
      children.push(compare);

      const currentValue = numberFromMoney(currentText);
      const compareValue = numberFromMoney(compareText);
      let savings = null;
      if (subscriptionSelected()) {
        savings = document.querySelector('.kaching-bundles__subscriptions__title')
          ?.textContent.match(/\d+\s*%/)?.[0]?.replace(/\s/g, '');
      } else if (currentValue !== null && compareValue && compareValue > currentValue) {
        savings = Math.round((1 - currentValue / compareValue) * 100) + '%';
      }
      if (savings) {
        const badge = document.createElement('span');
        badge.textContent = 'AHORRA ' + savings;
        children.push(badge);
      }
    }

    const signature = children.map((node) => node.tagName + ':' + node.textContent).join('|');
    if (price.dataset.selynePriceSignature !== signature) {
      price.replaceChildren(...children);
      price.dataset.selynePriceSignature = signature;
    }
    sticky.dataset.selyneState =
      (bar.dataset.dealBarId || String(selectedIndex)) +
      '|' +
      (subscriptionSelected() ? 'sub' : 'one') +
      '|' +
      currentText;
  }

  function requestPriceSync() {
    if (priceTimer) return;
    priceTimer = setTimeout(syncStickyPrice, 0);
  }

  function selectBundleFromSticky(select) {
    const bar = dealBars()[select.selectedIndex];
    const target = bar?.querySelector('.kaching-bundles__bar-wrapper') || bar;
    if (!target) return;
    target.click();
    setTimeout(requestPriceSync, 120);
    setTimeout(requestPriceSync, 420);
  }

  function connectCartRemoveButtons(root = document) {
    root.querySelectorAll('cart-remove-button').forEach((removeButton) => {
      if (removeButton.dataset.selyneRemoveBridge === 'true') return;
      removeButton.dataset.selyneRemoveBridge = 'true';
      removeButton.addEventListener('click', (event) => {
        if (window.Shopify?.designMode) interceptSplitBundleRemoval(event);
      }, true);
    });
  }

  function connectStickyButtons(root = document) {
    root.querySelectorAll(STICKY_BUTTON).forEach((button) => {
      if (button.dataset.selyneKachingBridge === 'true') return;
      button.dataset.selyneKachingBridge = 'true';

      button.addEventListener('click', (event) => {
        const formId = button.getAttribute('form');
        const configuredForm = formId ? document.getElementById(formId) : null;
        const primaryButton =
          configuredForm?.querySelector('button.atc-button.product-form__submit') ||
          document.querySelector('button.atc-button.product-form__submit');
        const form = configuredForm || primaryButton?.form;
        if (!form || !primaryButton || !selectedDealBar() || primaryButton.disabled) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        primaryButton.click();
        scheduleCartRefresh(850);
      }, true);
    });
  }

  function publishCartLinesUpdate(sourceButton) {
    if (window.Shopify?.designMode || !standardEvents?.CartLinesUpdateEvent) return;

    const bar = selectedDealBar();
    const variantId = VARIANT_BY_DEAL[bar?.dataset.dealBarId];
    const quantity = QUANTITY_BY_DEAL[bar?.dataset.dealBarId];
    if (!variantId || !quantity) return;

    const eventTarget =
      sourceButton.closest('product-info, product-form, .product, [data-product-id]') ||
      sourceButton.form ||
      document;
    const { CartLinesUpdateEvent, CartErrorEvent } = standardEvents;
    const deferred = CartLinesUpdateEvent.createPromise();

    eventTarget.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity }],
      promise: deferred.promise
    }));

    window.setTimeout(async () => {
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('cart.js ' + response.status);
        const ajaxCart = await response.json();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart)
        });
      } catch (error) {
        if (CartErrorEvent) {
          eventTarget.dispatchEvent(new CartErrorEvent({
            error: error.message,
            code: 'SERVICE_UNAVAILABLE'
          }));
        }
        deferred.reject(error);
      }
    }, 1100);
  }

  async function cartSignature() {
    let cart;
    if (window.Shopify?.designMode) {
      cart = JSON.parse(await xhrRequest('/cart.js?country=MX', {
        headers: { Accept: 'application/json' }
      }));
    } else {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('cart.js ' + response.status);
      cart = await response.json();
    }
    return [
      cart.item_count,
      cart.total_price,
      ...cart.items.map((item) => item.key + ':' + item.quantity + ':' + item.final_line_price)
    ].join('|');
  }

  async function waitForStableCart(run) {
    let previous = '';
    let stableReads = 0;
    for (let attempt = 0; attempt < 8; attempt += 1) {
      if (run !== cartRefreshRun) return false;
      try {
        const signature = await cartSignature();
        stableReads = signature === previous ? stableReads + 1 : 0;
        previous = signature;
        if (stableReads >= 1) return true;
      } catch (error) {
        console.warn('[SELYNE] No se pudo comprobar el carrito', error);
        return true;
      }
      await new Promise((resolve) => setTimeout(resolve, 260));
    }
    return true;
  }

  function xhrRequest(url, { method = 'GET', headers = {}, body = null } = {}) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(method, url, true);
      Object.entries(headers).forEach(([name, value]) => request.setRequestHeader(name, value));
      request.onload = () => {
        if (request.status >= 200 && request.status < 300) resolve(request.responseText);
        else reject(new Error('XHR ' + request.status + ' ' + url + ' ' + request.responseText));
      };
      request.onerror = () => reject(new Error('XHR network ' + url));
      request.send(body);
    });
  }

  async function refreshCartDrawer(run, forceOpen = false) {
    if (run !== cartRefreshRun) return;
    const currentDrawer = document.querySelector('cart-drawer');
    if (!currentDrawer) return;

    try {
      let html;
      if (window.Shopify?.designMode) {
        const localizedUrl = new URL(window.location.href);
        localizedUrl.searchParams.set('country', 'MX');
        html = await xhrRequest(localizedUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
      } else {
        const response = await fetch(window.location.href, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('drawer ' + response.status);
        html = await response.text();
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const freshDrawer = parsed.querySelector('cart-drawer');
      if (!freshDrawer || run !== cartRefreshRun) return;

      const wasOpen = currentDrawer.classList.contains('active') || forceOpen;
      currentDrawer.innerHTML = freshDrawer.innerHTML;
      currentDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      if (wasOpen) {
        currentDrawer.classList.add('active');
        currentDrawer.open?.();
      }
      currentDrawer.checkForClear?.();
      connectCartRemoveButtons(currentDrawer);
      normalizeDrawerBundleLabels(currentDrawer);
      if (wasOpen) startCartTimer(currentDrawer);

      const currentIcon = document.getElementById('cart-icon-bubble');
      const freshIcon = parsed.getElementById('cart-icon-bubble');
      if (currentIcon && freshIcon) currentIcon.innerHTML = freshIcon.innerHTML;
    } catch (error) {
      console.warn('[SELYNE] No se pudo refrescar el carrito lateral', error);
    }
  }

  function scheduleCartRefresh(delay = 650) {
    clearTimeout(cartTimer);
    const run = ++cartRefreshRun;
    cartTimer = setTimeout(async () => {
      const settled = await waitForStableCart(run);
      if (settled) await refreshCartDrawer(run);
    }, delay);
  }


  const lineSellingPlanId = (item) =>
    item?.selling_plan_allocation?.selling_plan?.id ||
    item?.selling_plan_allocation?.selling_plan_id ||
    '';

  function duplicateVariantRows(removeButton) {
    const row = removeButton.closest('.cart-item');
    const variantId = row?.querySelector('input[data-quantity-variant-id]')?.dataset.quantityVariantId;
    if (!variantId) return [];
    return [...document.querySelectorAll('cart-drawer .cart-item input[data-quantity-variant-id]')]
      .filter((input) => input.dataset.quantityVariantId === variantId);
  }

  async function removeCompleteKachingBundle(removeButton) {
    const row = removeButton.closest('.cart-item');
    const line = Number(removeButton.dataset.index || row?.dataset.index);
    if (!line) return;

    let cart;
    if (window.Shopify?.designMode) {
      cart = JSON.parse(await xhrRequest('/cart.js?country=MX', {
        headers: { Accept: 'application/json' }
      }));
    } else {
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('cart.js ' + cartResponse.status);
      cart = await cartResponse.json();
    }
    const clickedItem = cart.items[line - 1];
    if (!clickedItem) throw new Error('No se encontró la línea del carrito');

    const matchingLines = cart.items.filter((item) =>
      item.variant_id === clickedItem.variant_id &&
      lineSellingPlanId(item) === lineSellingPlanId(clickedItem)
    );
    const isSplitKachingBundle =
      matchingLines.length > 1 &&
      matchingLines.some((item) => Number(item.final_line_price) === 0 || Number(item.final_price) === 0);
    const linesToRemove = isSplitKachingBundle ? matchingLines : [clickedItem];
    const updates = Object.fromEntries(linesToRemove.map((item) => [item.key, 0]));

    if (window.Shopify?.designMode) {
      await xhrRequest('/cart/update.js?country=MX', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      window.location.reload();
    } else {
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      if (!updateResponse.ok) throw new Error('cart/update.js ' + updateResponse.status);
    }
  }

  async function addBundleInThemeEditor(button, overrideDealId = '', overrideSubscription = false) {
    const bar = selectedDealBar();
    const dealId = overrideDealId || bar?.dataset.dealBarId;
    const variantId = VARIANT_BY_DEAL[dealId];
    const quantity = QUANTITY_BY_DEAL[dealId];
    if (!variantId || !quantity) return;
    const item = { id: Number(variantId), quantity };
    if (overrideSubscription || subscriptionSelected()) {
      item.selling_plan = Number(SUBSCRIPTION_PLAN_ID);
    }
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    try {
      await xhrRequest('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      });
      const run = ++cartRefreshRun;
      await refreshCartDrawer(run, true);
    } catch (error) {
      console.warn('[SELYNE] No se pudo añadir el bundle en el editor de temas', error);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }
  }

  function interceptThemeEditorAdd(event) {
    if (!window.Shopify?.designMode) return false;
    const button = event.target.closest('button.atc-button.product-form__submit');
    if (!button) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    const bar = selectedDealBar();
    const dealId = bar?.dataset.dealBarId;
    const url = new URL(window.location.href);
    if (url.searchParams.get('country') !== 'MX' && dealId) {
      url.searchParams.set('country', 'MX');
      url.searchParams.set('_selyne_add', dealId);
      if (subscriptionSelected()) url.searchParams.set('_selyne_sub', '1');
      window.location.replace(url.toString());
      return true;
    }
    syncProductVariant();
    addBundleInThemeEditor(button);
    return true;
  }

  function resumeThemeEditorAdd() {
    if (!window.Shopify?.designMode) return;
    const url = new URL(window.location.href);
    const dealId = url.searchParams.get('_selyne_add');
    if (!dealId) return;
    const wantsSubscription = url.searchParams.get('_selyne_sub') === '1';
    url.searchParams.delete('_selyne_add');
    url.searchParams.delete('_selyne_sub');
    window.history.replaceState({}, '', url.toString());
    window.setTimeout(() => {
      const button = document.querySelector('button.atc-button.product-form__submit');
      const bar = dealBars().find((candidate) => candidate.dataset.dealBarId === dealId);
      if (bar) syncProductVariant(bar);
      if (button) addBundleInThemeEditor(button, dealId, wantsSubscription);
    }, 900);
  }

  function interceptSplitBundleRemoval(event) {
    const removeButton =
      event.target.closest?.('cart-remove-button') ||
      event.currentTarget?.closest?.('cart-remove-button');
    if (!removeButton || removeButton.dataset.selyneBundleRemoving === 'true') return false;
    if (!window.Shopify?.designMode && duplicateVariantRows(removeButton).length < 2) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    removeButton.dataset.selyneBundleRemoving = 'true';

    removeCompleteKachingBundle(removeButton)
      .catch(async (error) => {
        console.warn('[SELYNE] No se pudo retirar el bundle completo', error);
        const row = removeButton.closest('.cart-item');
        const line = Number(removeButton.dataset.index || row?.dataset.index);
        if (!line) return;
        const options = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ line, quantity: 0 })
        };
        if (window.Shopify?.designMode) await xhrRequest('/cart/change.js?country=MX', options);
        else await fetch('/cart/change.js', { ...options, credentials: 'same-origin' });
      })
      .finally(() => {
        delete removeButton.dataset.selyneBundleRemoving;
        scheduleCartRefresh(120);
      });

    return true;
  }

  window.addEventListener('click', (event) => {
    if (interceptThemeEditorAdd(event)) return;
    if (window.Shopify?.designMode) interceptSplitBundleRemoval(event);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('select.sticky-atc__variant-select')) {
      selectBundleFromSticky(event.target);
      return;
    }
    if (event.target.matches('cart-drawer input[name="updates[]"]')) {
      scheduleCartRefresh();
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (interceptSplitBundleRemoval(event)) return;

    const addButton = event.target.closest(
      'button.atc-button.product-form__submit, ' + STICKY_BUTTON
    );
    if (addButton && !addButton.disabled) {
      installShopifyAnalyticsFallback();
      publishCartLinesUpdate(addButton);
    }

    const clickedBar = event.target.closest(DEAL_BAR);
    if (clickedBar) syncProductVariant(clickedBar);
    if (event.target.closest(DEAL_BAR + ' .kaching-bundles__bar-wrapper, .kaching-bundles__subscriptions')) {
      setTimeout(() => {
        syncProductVariant();
        requestPriceSync();
      }, 80);
      setTimeout(() => {
        syncProductVariant();
        requestPriceSync();
      }, 360);
    }

    if (event.target.closest(
      'cart-remove-button, cart-drawer quantity-input button, button.atc-button.product-form__submit'
    )) {
      scheduleCartRefresh(event.target.closest('button.atc-button.product-form__submit') ? 850 : 650);
    }
  }, true);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) =>
      mutation.target.closest?.('.kaching-bundles, sticky-atc') ||
      mutation.addedNodes.length
    )) {
      connectStickyButtons();
      connectCartRemoveButtons();
      requestPriceSync();
    }
  });

  function boot(root = document) {
    installCriticalStyles();
    installShopifyAnalyticsFallback();
    [250, 750, 1500, 3000, 6000].forEach((delay) => {
      setTimeout(installShopifyAnalyticsFallback, delay);
    });
    connectStickyButtons(root);
    connectCartRemoveButtons(root);
    syncProductVariant();
    normalizeDrawerBundleLabels();
    resumeThemeEditorAdd();
    requestPriceSync();
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked', 'checked']
    });
    setTimeout(() => {
      syncProductVariant();
      requestPriceSync();
    }, 300);
    setTimeout(() => {
      syncProductVariant();
      requestPriceSync();
    }, 900);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    connectStickyButtons(event.target);
    requestPriceSync();
  });
})();
